import { GameManager } from "../GameManager";
import { IBattleDetails, IIsBattleGameInfo, IBattleInitInfo, IUserDetails } from "./GzpInterfaces";
import * as Carrom from "carrom-king-engine";
import { AudioManager } from "../AudioManager";
import { GameVars } from "../GameVars";
import { klona } from 'klona';
import { ColyseusManager } from "../ColyseusManager";
/* 
  Utility class for Battles
*/
declare var gamezop: any;
export default class BattleUtils {
  public static battleCount: number = 0;
  public static battleDetails: IBattleDetails; // All the details regarding a battle
  public static battleGameInfo: IIsBattleGameInfo; // Info from gamezop.isBattleGame()
  public static battleInitDetails: IBattleInitInfo; // Info containing matchid and player details from gamezop.gameInit()
  // "https://static.gamezop.io/users/Pw-pic.png?v=23"
  public static battlePlayerData: IUserDetails = {firstName: "player", gzpId: BattleUtils.getRandomGzpId(), photo: undefined, isClient: false};
  public static battleOpponentData: IUserDetails = {firstName: "opponent", gzpId: BattleUtils.getRandomGzpId(), photo: undefined, isClient: false}; 
  public static isBattle: boolean = false;  
  public static playerProfileCache = undefined;
  public static opponentProfileCache = undefined;
  public static doesBattleHasBots: boolean = false;
  public static battlePlayers: IUserDetails[] = []
  public static test_battleInitData = {matchId: "", players: [{firstName: "Anandu", gzpId: "Pw", photo: "https://static.gamezop.io/users/Pw-pic.png?v=23"},
  {firstName: "Dibyanshu", gzpId: "N6", photo: "https://static.gamezop.io/users/N6-pic.png?v=23"}]};
  
  public static battleMode: string;
  public static setPlayerData = async function() {
    const w = <any> window;
    w.onGameInit = BattleUtils.onGameInit.bind(this);
    let sdkData: any;
    try {
      sdkData = await gamezop.isLoggedIn();
    } catch (e) {
      console.log("Error occured due to", e);
    } 
    if (sdkData && sdkData.userData) {
      // sometimes name can be empty, especially beginners.
      if (sdkData.userData.firstName.length > 0) {
        this.battlePlayerData.firstName = sdkData.userData.firstName;
      } else {
        this.battlePlayerData.firstName = this.getNameFromPhone(sdkData.userData.phone);
      }
      this.battlePlayerData.photo = sdkData.userData.photo;
      this.battlePlayerData.gzpId = sdkData.userData.gzpId;
      console.warn("Logged in as ", this.battlePlayerData);
    } else {
      this.battlePlayerData.firstName = this.getRandomFirstName();
      this.battlePlayerData.photo = undefined; /* "https://static.gamezop.io/users/Pw-pic.png?v=23" */
      this.battlePlayerData.gzpId = this.getRandomGzpId();
      console.warn("Not logged In as ", this.battlePlayerData);
    }
    // if (!sdkData && !this.isBattle && GameVars.playerData.name)
    //   this.battlePlayerData.firstName = GameVars.playerData.name;
    // else
    this.battlePlayerData.firstName = this.trimName(this.battlePlayerData.firstName);
    console.log("this.battlePlayerData", this.battlePlayerData)
    return;
  };

  public static getNameFromPhone(phoneNumber: string) {
    let splitList = phoneNumber.split("+91");
    let phNumber: string = "";
    if (splitList.length === 2) {
      phNumber = splitList[1];
    } else {
      phNumber = splitList[0];
    }
    return phNumber.substr(0, 4) + "xxxxxx";
  }
  
  public static getRandomFirstName() {
    const rndCode = Math.random().toFixed(5).split(".")[1];
    return "Guest_" + rndCode;
  }

  public static setBattleProperties(info: IIsBattleGameInfo): void {
    this.isBattle = true;
    this.battleGameInfo = info;
    this.battleDetails = JSON.parse(info.data);
    this.battleMode = this.battleDetails.gameConfig || Carrom.GameMode.FREESTYLE;
  }

  public static getRandomGzpId() {
    const rndCode = Math.random().toFixed(5).split(".")[1];
    return "gzp_anon_" + rndCode;
  }

  public static setPropertiesOnGameInit(battleDetails: IBattleInitInfo) {
    let battleInitDetails =  klona(battleDetails);
    if (battleInitDetails.matchId === "") {
      console.warn("No match found");
      return;
    }
    // this.isBattle = true; // should be move to isBattleGame check.
    this.battleInitDetails = battleInitDetails;
    this.battleMode = this.battleInitDetails.gameConfig || Carrom.GameMode.FREESTYLE;
    console.warn("Calling battle init");
  
    // NetworkManager.networkEventEmitter.emit("battle_init");
    ++ BattleUtils.battleCount;
    this.doesBattleHasBots = false;
    this.battlePlayers = battleDetails.players
    /* 
      Go through the players data given by astro
      - store player's and opponents data separately
      - Also checks if battle has bots
    */
    for (let i = 0; i < this.battleInitDetails.players.length; i++) {
      if (this.battleInitDetails.players[i].isClient) {
        this.battlePlayerData = this.battleInitDetails.players[i];
      } else {
        if (this.battleInitDetails.players[i].gzpId) {
          if (!this.doesBattleHasBots && this.battleInitDetails.players[i].isBot) {
            this.doesBattleHasBots = true;
          }
          this.battleOpponentData = this.battleInitDetails.players[i];
        }
      }
    }
    this.battlePlayerData.firstName = this.trimName(this.battlePlayerData.firstName);
    this.battleOpponentData.firstName = this.trimName(this.battleOpponentData.firstName);
    console.log("playuer data", this.battlePlayerData);
    console.log("opp data", this.battleOpponentData);
    GameVars.playerData.name = BattleUtils.battlePlayerData.firstName;

    GameManager.onGameModeSelected(this.battleMode);
    GameManager.onDifficultySelected(Carrom.Difficulty.BEGINNER, this.doesBattleHasBots);

  }

  public static getValidLoadUrl = (url: string) => {
    const currentImageUrl = url;
    const urlWithoutCache = currentImageUrl.split("?")[0];
    return urlWithoutCache;
  }

  public static onGameInit(matchData: IBattleInitInfo): void {
    console.log("🚀 ~ file: BattleUtils.ts ~ line 107 ~ BattleUtils ~ onGameInit ~ matchData", matchData)
    this.setPropertiesOnGameInit(matchData);
  }

  public static trimName = (name: string) => {
    return name.substr(0, 8);
  }

  public static isValidUrl = (url: string) => {
    if (url.split(".png").length === 2) {
      return true;
    }
    return false;
  }

  /* 
    Hits `/bot-battle-over` POST api to carrom server to declare the battle with bots

    - `playerScore` - Score of the player (0 or 1)
  */
  public static sendBotBattleOverState = async (playerScore: number) => {
    let restEndpoint = ColyseusManager.restEndpoint + "/bot-battle-over";
    let opponentScore = (playerScore + 1) % 2
    let scoreList = [{gzpId: BattleUtils.battlePlayerData.gzpId, score: playerScore, isBot: false},
       {gzpId: BattleUtils.battleOpponentData.gzpId, score: opponentScore, isBot: true}]; 
    const scoreObj = {scores: scoreList, contestId: BattleUtils.battleInitDetails.matchId};
    console.log('ScoreObj => ', scoreObj);

    fetch(restEndpoint, {
      method: 'POST', 
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(scoreObj)
    })
    .then((resp) => {
      console.log(resp);
    })
    .catch((err) => {
      console.log(err);
    })
  }
}
